// @flow
import type { ReduxStore } from "../types";

export type BeforeRenderHookProps = {
  store: ReduxStore,
  request?: HttpServletRequestJava,
};
export type BeforeRenderHook = (props: BeforeRenderHookProps) => void;

/**
 * Process handlers that need to be run before the react application starts,
 * for example to start a third party service<br>
 * An object with the store is available to make it possible to read state available in the redux store,
 * for example server preferences, and the request is available to retrieve request information
 *
 */
export const handleBeforeRenderHooks = (
  beforeRenderHooks: Array<BeforeRenderHook> = [],
  props: BeforeRenderHookProps,
) => {
  if (beforeRenderHooks.length > 0) {
    for (const beforeRenderHook of beforeRenderHooks) {
      beforeRenderHook(props);
    }
  }
};
